/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import ContactMail from "@mui/icons-material/ContactMail";
import Phone from "@mui/icons-material/Phone";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// sections for this page
import AboutUs from "pages-sections/services/google-ads-services/AboutUs.js";
import Examples from "pages-sections/services/google-ads-services/Examples.js";
import AdsPackage from "pages-sections/services/google-ads-services/AdsPackage.js";
import Guarantee from "pages-sections/services/google-ads-services/Guarantee.js";
import WhyUs from "pages-sections/services/google-ads-services/WhyUs.js";
import OurApproach from "pages-sections/services/google-ads-services/OurApproach.js";

import SectionText from "pages-sections/services/google-ads-services/SectionText.js";

import SectionBlogInfo from "pages-sections/blog-post/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/SectionSimilarStories.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";

import profilePageStyle from "styles/jss/nextjs-material-kit-pro/pages/profilePageStyle.js";
import nsStyle from "styles/jss/nextjs-material-kit-pro.js";
import classNames from "classnames";
import Box from "@mui/material/Box";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Image from "next/image";

import blogPostPageStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Google Ad Services - Tribalism"
        image="/img/sections/services/all-services/4-sm.webp"
        url="https://www.tribalism.com.au/services/web-analytics"
        type="article"
        description="We are Digital Marketing Agency based in Melbourne. We can help you optimize your online strategy using Google Ads!"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />

      <Parallax
        image="/img/sections/services/seo-services/5-sm.webp"
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer sx={{ mt: { md: 3, lg: 0 }, mx: { xs: 0, md: 0 } }}>
            <GridItem xs={12} md={8}>
              <Box display={{ xs: "none", lg: "block" }}>
                <div
                  style={{
                    backgroundColor: "rgba(0,0,0,0.55)",
                    borderRadius: "10px",
                    display: "inline-block",
                    paddingLeft: "20px",
                    paddingBottom: "20px",
                    paddingRight: "20px",
                  }}
                >
                  <h1 className={classes.title}>
                    Try our unique and amazing Google Ads Services!
                  </h1>

                  <h4 className={classes.subtitle}>
                    <ul>
                      <li>
                        Do you want the smartest people in SEO working on your
                        website?{" "}
                      </li>
                      <li>Do you want clear, proven, data driven methods? </li>
                      <li>
                        Do you want honest and engaged people to understand your
                        issues?{" "}
                      </li>
                      <li>Do you want the best seo agency in Australia?</li>
                    </ul>
                  </h4>

                  <h2 style={{ color: "white" }}>Then get in contact today!</h2>
                  <br />
                  <Button color="rose" size="lg" href="/contact-us" round>
                    <Phone /> Contact Us
                  </Button>
                </div>
              </Box>

              <Box display={{ xs: "block", lg: "none" }}>
                <div
                  style={{
                    backgroundColor: "rgba(0,0,0,0.55)",
                    borderRadius: "10px",
                    display: "inline-block",
                    paddingLeft: "10px",
                    paddingBottom: "20px",
                    paddingRight: "20px",
                  }}
                >
                  <h3 className={classes.title}>
                    Try our unique and amazing SEO Services!
                  </h3>

                  <h5 className={classes.subtitle}>
                    <ul>
                      <li>
                        Do you want the smartest people in SEO working on your
                        website?{" "}
                      </li>
                      <li>Do you want clear, proven, data driven methods? </li>
                      <li>
                        Do you want honest and engaged people to understand your
                        issues?{" "}
                      </li>
                      <li>Do you want the best seo agency in Australia?</li>
                    </ul>
                  </h5>

                  <h5 style={{ color: "white" }}>Then get in contact today!</h5>
                  <br />
                  <Button color="rose" size="lg" href="/contact-us" round>
                    <Phone /> Contact Us
                  </Button>
                </div>
              </Box>
            </GridItem>
            <GridItem
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: { xs: "none", md: "block" }, width: "100%" }}>
                <a href="/about/profile-scott-sunderland">
                  <img
                    id="optionalstuff"
                    srcSet="/img/faces/scott-profile-small-noback-300px-bw.webp  300w, /img/faces/scott-profile-small-noback-400px-bw.webp 400w"
                    sizes="(max-width: 900px) 0px, (max-width: 1200px) 300px, 400px"
                    style={{ maxWidth: "100%", backgroundColor: "transparent" }}
                  />
                </a>
              </Box>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classes.main} style={{ marginTop: "30px" }}>
        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgpink2.jpg')",
            boxShadow:
              "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <AboutUs />
          </div>
        </div>

        <div style={{ backgroundColor: "white" }}>
          <div className={classes.container}></div>
        </div>

        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgblue1.jpg')",
          }}
        >
          <div className={classes.container}>
            <Examples />
          </div>
        </div>

        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bg2.jpg')",
          }}
        >
          <div className={classes.container}>
            <AdsPackage />
          </div>
        </div>

        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bg1.jpg')",
            boxShadow:
              "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <Guarantee />
          </div>
        </div>

        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgpink2.jpg')",
            boxShadow:
              "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <WhyUs />
          </div>
        </div>

        <div style={{ backgroundColor: "white" }}>
          <div className={classes.container}></div>
        </div>

        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgblue1.jpg')",
          }}
        >
          <div className={classes.container}>
            <OurApproach />
          </div>
        </div>

        <Section4Clients id="clients" />
        <Section8Contacts id="testimonials" />
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Creative Tim
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/presentation?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    About us
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://blog.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Blog
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/license?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Licenses
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , made with{" "}
              <Favorite className={classes.icon} /> by{" "}
              <a
                href="https://www.creative-tim.com?ref=njsmkp-blog-post"
                target="_blank"
              >
                Creative Tim
              </a>{" "}
              for a better web.
            </div>
          </div>
        }
      />
    </div>
  );
}
